import type { ComponentPropsWithoutRef, JSX, PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { Box } from '@change-corgi/design-system/layout';

type Props = Readonly<{ viewportSize: 'small' | 'normal' }>;

type BoxProps = ComponentPropsWithoutRef<typeof Box>;

/**
 * Composes a Box that will only be visible at certain viewport sizes. Note that this uses `display:
 * none` which means the children are rendered in the React tree regardless of viewport.
 */
export function ResponsiveBox({
	children,
	viewportSize: size,
	...rest
}: PropsWithChildren<Props & BoxProps>): JSX.Element {
	const display = useMemo(() => (size === 'small' ? ['block', 'none'] : ['none', 'block']), [size]);

	return (
		<Box {...rest} sx={{ display }}>
			{children}
		</Box>
	);
}
